import { isSessionEmpty, type SessionWithEntity } from "./multi-session";

export type SessionActions = {
  canOpen: boolean;
  canEdit: boolean;
  canArchive: boolean;
  canUnarchive: boolean;
};

export function getSessionActions(session: SessionWithEntity): SessionActions {
  const archived = !!session.archived_at;
  const empty = isSessionEmpty(session);
  return {
    canOpen: !archived,
    canEdit: !archived,
    canArchive: !archived && !empty,
    canUnarchive: archived,
  };
}
